import {
    DISMISS_NOTIFICATION_START,
    DISMISS_NOTIFICATION_SUCCESS,
    DISMISS_NOTIFICATION_FAIL
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    notificationDismissSuccess: { id: null, success: false },
    notificationDismissFail: { id: null, fail: false }
};

const notificationDismissing = (state, { notificationId }) => {
    return {
        ...state,
        notificationDismissSuccess: { id: notificationId, success: false },
        notificationDismissFail: { id: notificationId, fail: false }
    };
};

const dismissNotificationFinished = (isSuccess) => (state, { notificationId }) => {
    return {
        ...state,
        notificationDismissSuccess: { id: notificationId, success: isSuccess },
        notificationDismissFail: { id: notificationId, fail: !isSuccess }
    };
};

export const getNotificationDismissSuccessWithId = (state, id) =>
    state.notification.notificationDismissSuccess.id === id && state.notification.notificationDismissSuccess.success;
export const getNotificationDismissFailWithId = (state, id) =>
    state.notification.notificationDismissFail.id === id && state.notification.notificationDismissFail.fail;

const handlers = {
    [DISMISS_NOTIFICATION_START]: notificationDismissing,
    [DISMISS_NOTIFICATION_SUCCESS]: dismissNotificationFinished(true),
    [DISMISS_NOTIFICATION_FAIL]: dismissNotificationFinished(false)
};

export default function notification(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
